import {Record} from 'immutable';
import {DEFAULT_COLOR_ID, DEFAULT_STYLE_ID} from '~/constants/ProductConstants';

const Product = Record({
  colorId: DEFAULT_COLOR_ID,
  styleId: DEFAULT_STYLE_ID,
  visible: true
});
export default Product;
